import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales/ETLCodes";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface IViewButtonProps extends ICustomButtonProps {}

export const ViewButton: React.FunctionComponent<IViewButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  text,
  disabled,
  intent = Intent.NONE,
}) => {
  const { t } = useTl();

  return (
    <Button
      icon={IconNames.EYE_OPEN}
      title={text ? text : t(ETLCodes.View)}
      minimal={minimal}
      onClick={onClick}
      text={text ? text : minimal ? null : t(ETLCodes.View)}
      intent={intent}
      loading={loading}
      disabled={disabled}
    />
  );
};
